<template>
  <div>
    <!-- <div class="perfect-budget-style" v-if="clientInfoList.length > 0 "> -->
    <div v-if="filterHeadConfig.length > 0" class="perfect-budget-style">
      <!-- search -->
      <div class="search-row-header">
        <el-row class="search-row" :gutter="10" style="padding-top: 0">
          <el-col :span="6">
            <el-select
              v-model="queryParam.orgCode"
              placeholder="选择区域"
              multiple
              collapse-tags
              clearable
              style="width: 100%"
            >
              <el-option
                v-for="item in orgList"
                :key="item.orgId"
                :value="item.orgCode"
                :label="item.orgName.split('|')[0]"
              />
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select
              v-model="queryParam.typeId"
              placeholder="选择预算"
              multiple
              filterable
              collapse-tags
              clearable
              @change="changeBudget"
              style="width: 100%"
            >
              <el-option
                v-for="item in budgetList"
                :label="`${item.typeName}（${item.trCode}）`"
                :value="item.typeId"
                :key="item.typeId"
              />
            </el-select>
          </el-col>
          <el-col :span="2" class="buttonCol">
            <el-button class="btn-red" size="medium" @click="handleSearch()"
              >搜索</el-button
            >
          </el-col>
          <el-col :span="2">
            <el-button
              type="info"
              class="btn-reset"
              size="medium"
              @click="handleReset()"
              >重置</el-button
            >
          </el-col>
        </el-row>
      </div>

      <!-- 展示数据 -->
      <ul class="show-data-content">
        <li class="show-content-li">
          <p>可用预算:</p>
          <span>{{ listObj.availableAmount | formatNumber("number") }}</span>
        </li>

        <li class="show-content-li">
          <el-tooltip
            class="item"
            effect="dark"
            content="待审批订单占用的预算"
            placement="top-start"
          >
            <i class="el-icon-question"></i>
          </el-tooltip>
          <p>冻结预算:</p>
          <span>{{ listObj.freezeAmount | formatNumber("number") }}</span>
        </li>
        <li class="show-content-li">
          <el-tooltip
            class="item"
            effect="dark"
            content="执行中订单占用的预算"
            placement="top-start"
          >
            <i class="el-icon-question"></i>
          </el-tooltip>
          <p>已用预算:</p>
          <span>{{ listObj.usedAmount | formatNumber("number") }}</span>
        </li>
        <li class="show-content-li">
          <p>总计预算:</p>
          <span>{{ listObj.totalAmount | formatNumber("number") }}</span>
        </li>
      </ul>
      <!-- table数据 -->
      <div>
        <el-table
          :data="clientInfoList"
          max-height="500"
          :key="tableHeadConfig.length"
          v-loading="listLoading"
          row-key="orgCode"
          default-expand-all
          :cell-style="cellStyle"
          :header-cell-style="{
            background: '#ffdade',
            color: '#606266',
            textAlign: 'center',
            fontSize: '14px',
          }"
          :tree-props="{
            children: 'areaBudgetInfos',
            hasChildren: 'hasChildren',
          }"
          class="ss"
        >
          <el-table-column
            label="Region/Area"
            min-width="145"
            prop="regionName"
            fixed="left"
            align="left"
          />
          <el-table-column
            v-for="(head, index) in filterHeadConfig"
            :key="index"
            :label="head.typeName"
            :prop="head.typeName"
            align="center"
          >
          <template slot="header">
            <div>{{ `${head.typeName} ` }}</div>
            <div style="color:#C8102D;font-weight:400;font-size:12px">{{`( ${head.trCodeName} )`}}</div>
          </template>
            <el-table-column label="可用" align="center" min-width="99">
              <template slot-scope="{ row }">
                {{
                  row[head.typeName + "-" + "available"]
                    | formatNumber("number")
                }}
              </template>
            </el-table-column>
            <el-table-column label="冻结" align="center" min-width="99">
              <template #header>
                <span>冻结</span>
                <el-tooltip
                  effect="dark"
                  content="待审批订单占用的预算"
                  placement="top-start"
                >
                  <span><i class="el-icon-question"></i></span>
                </el-tooltip>
              </template>
              <template slot-scope="{ row }">
                {{
                  row[head.typeName + "-" + "freeze"] | formatNumber("number")
                }}
              </template>
            </el-table-column>
            <el-table-column label="已用" align="center" min-width="99">
              <template #header>
                <span>已用</span>
                <el-tooltip
                  effect="dark"
                  content="执行中订单占用的预算"
                  placement="top-start"
                >
                  <span><i class="el-icon-question"></i></span>
                </el-tooltip>
              </template>
              <template slot-scope="{ row }">
                {{ row[head.typeName + "-" + "used"] | formatNumber("number") }}
              </template>
            </el-table-column>
            <el-table-column
              label="总计"
              align="center"
              min-width="99"
              class-name="totalColor"
              label-class-name="totalClass"
            >
              <template slot-scope="{ row }">
                {{
                  row[head.typeName + "-" + "total"] | formatNumber("number")
                }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            label="合计"
            prop="total"
            align="center"
            fixed="right"
            class-name="availableStyle"
            width="399"
          >
            <el-table-column
              align="center"
              label="可用"
              fixed="right"
              class-name="fontSize"
              prop="availableAmount"
              width="100"
            >
              <template slot-scope="{ row }">
                {{ row.availableAmount | formatNumber("number") }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              fixed="right"
              label="冻结"
              class-name="fontSize"
              prop="freezeAmount"
              width="100"
            >
              <template #header>
                <span>冻结</span>
                <el-tooltip
                  effect="dark"
                  content="待审批订单占用的预算"
                  placement="top-start"
                >
                  <span><i class="el-icon-question"></i></span>
                </el-tooltip>
              </template>
              <template slot-scope="{ row }">
                {{ row.freezeAmount | formatNumber("number") }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              fixed="right"
              label="已用"
              class-name="fontSize"
              prop="usedAmount"
              width="100"
            >
              <template #header>
                <span>已用</span>
                <el-tooltip
                  effect="dark"
                  content="执行中订单占用的预算"
                  placement="top-start"
                >
                  <span><i class="el-icon-question"></i></span>
                </el-tooltip>
              </template>
              <template slot-scope="{ row }">
                {{ row.usedAmount | formatNumber("number") }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              fixed="right"
              label="总计"
              prop="totalAmount"
              class-name="totalColor"
              label-class-name="totalClass"
              width="100"
            >
              <template slot-scope="{ row }">
                {{ row.totalAmount | formatNumber("number") }}
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="no-data" v-else>当前暂无预算数据，请联系BU进行配置！</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import budgetApi from '@/api/budget'
// import _ from 'lodash'
// 千分符
const filters = {
  formatNumber (number, type) {
    if (!number && number !== 0) return
    if (type === 'number') {
      return number.toLocaleString()
    } else if (type === 'money') {
      return '￥' + number.toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
    }
  }
}
export default {
  name: 'perfect-budget',
  data () {
    return {
      val: '',
      listLoading: false,
      page: 1,
      buList: [], // buse
      orgList: [], // 区域
      budgetList: [], // 预算
      // 搜索条件
      queryParam: {
        // buCode: this.userInfo.buCode,
        orgCode: [],
        typeId: []
      },
      buListPool: {},
      // 展示数据
      listObj: {},
      // table标题-预算池
      tableHeadConfig: [],
      // 当BUSE账号|regin账号---table数据
      clientInfoList: [],
      // 预算池
      budgetPoolDetailList: [
        {
          itemName: '',
          note: ''

        }
      ]
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    filterHeadConfig () {
      let headList = []
      if (this.queryParam.typeId.length) {
        // headList = this.tableHeadConfig.filter(head => head.typeId === this.queryParam.typeId)
        headList = this.tableHeadConfig.filter(head => {
          const isHas = this.queryParam.typeId.includes(head.typeId)
          if (isHas) {
            return true
          }
        })
      } else {
        headList = this.tableHeadConfig
      }
      return headList
    }
  },
  filters,
  created () {
    // 区域list
    this.getOrgList()
    // 预算list
    this.getBudget()
    // table-list
    this.handleSearch()
  },
  methods: {
    cellStyle (val) {
      if (val.columnIndex === 0) {
        return 'background: rgb(246,247,251);border-bottom: 1px solid rgb(246, 247, 251);'
      }
      if (val.column.fixed === 'right') {
        return 'background: rgb(246,247,251);border-bottom: 1px solid rgb(246, 247, 251);font-size: 12px;'
      }
      if (val.column.label === '可用' || val.column.label === '冻结' || val.column.label === '已用' || val.column.label === '总计') {
        return 'font-size: 12px;'
      }
    },
    // 获取区域
    getOrgList () {
      let params = {
        buCode: this.userInfo.buCode
      }
      budgetApi.getOrgList(params).then(res => {
        if (res.data.resultCode === '0') {
          // this.queryParam.orgCode.push(res.data.resultData.orgList[0].orgCode)
          this.orgList = res.data.resultData.orgList
        }
      })
    },
    changeBudget () {
      this.handleSearch()
    },
    // 获取预算池名称
    getBudget () {
      let params = {
        buCode: this.userInfo.buCode
      }
      budgetApi.getTableHeadConfig(params).then(res => {
        if (res.data.resultCode === '0') {
          this.budgetList = res.data.resultData.budgetTypeList// 下拉框
          this.tableHeadConfig = res.data.resultData.budgetTypeList // 表头
        }
      })
    },
    // 搜索|获取-table数据
    handleSearch () {
      this.loading = true
      let params = {
        buCode: this.userInfo.buCode,
        typeIds: this.queryParam.typeId,
        regionCodes: this.queryParam.orgCode
      }
      budgetApi.getPerfectThemeList(params).then(res => {
        if (res.data.resultCode === '0') {
          let resData = res.data.resultData.budgetInfoList
          this.clientInfoList = this.deepCLone(resData)
          this.listObj = this.clientInfoList[0]
          let arrList = this.clientInfoList.slice(1, this.clientInfoList.length)
          this.clientInfoList[0].regionName = '合计'
          arrList.push(this.clientInfoList[0])
          this.clientInfoList = arrList
        }
      }).catch(() => {
        this.loading = false
      })
    },
    // 处理数据
    deepCLone (arr) {
      let tempArr = []
      arr.forEach(parent => {
        let tempObj = {
          orgCode: parent.regionCode,
          regionName: parent.regionName.split('|')[0],
          budgetLevel: parent.budgetLevel,
          budgetInfos: parent.budgetInfos,
          areaBudgetInfos: parent.areaBudgetInfos || [],
          availableAmount: parent.availableAmount,
          freezeAmount: parent.freezeAmount,
          usedAmount: parent.usedAmount,
          totalAmount: parent.totalAmount
        }
        tempObj.budgetInfos.forEach(item => {
          const mapObj = {
            typeName: item.typeName,
            available: item.availableAmount,
            freeze: item.freezeAmount,
            used: item.usedAmount,
            total: item.totalAmount
          }
          tempObj[item.typeName + '-available'] = mapObj.available
          tempObj[item.typeName + '-freeze'] = mapObj.freeze
          tempObj[item.typeName + '-used'] = mapObj.used
          tempObj[item.typeName + '-total'] = mapObj.total
        })
        if (tempObj.budgetLevel === 10) {
          tempObj.areaBudgetInfos = this.deepCLone(parent.areaBudgetInfos)
        }
        tempArr.push(tempObj)
      })
      return tempArr
    },
    // 重置
    handleReset () {
      this.queryParam.orgCode = []
      this.queryParam.typeId = []
      this.handleSearch()
    }
  }
}
</script>

<style lang="scss" scoped>
.perfect-budget-style {
  // background: pink;
  width: 1200px;
  margin: 0 auto;
  ::v-deep .el-table__expand-icon {
    display: none !important;
  }
 ::v-deep .el-table thead {
    color: #131313;
  }
  .no-data {
    text-align: center;
  }
  .btn {
    margin: 25px;
    text-align: center;
  }

  .search-row-header {
    display: flex;
    justify-content: space-between;
    .search-row {
      width: 1000px;
    }
  }
  li,
  ul {
    list-style: none;
  }
  ::v-deep .el-col-3 {
    text-align: center;
  }
  .show-data-content {
    display: flex;
    justify-content: space-between;
    width: 600px;
    padding: 0px;
    .show-content-li {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-right: 5px;
      p {
        margin-right: 5px;
      }
      span {
        flex: 1;
        color: #c8102d;
      }
    }
  }

  // .search-row {
  //   margin-bottom: 15px;
  //   padding: 20px 20px 0 20px;
  //   line-height: 36px;
  //   .el-col {
  //     width: 505px;
  //     padding-bottom: 10px;
  //   }
  // }
}
::v-deep .totalClass {
  color: #ca0c28;
}
::v-deep .totalColor {
  color: #ca0c28;
  font-size: 12px;
}
::v-deep .fontSize {
  font-size: 12px;
}
// .buttonCol{
//   margin-right: 9px;
// }
</style>
